import AuthService from '@/service/AuthService'
import store from '@/store'

export default async function(to, from, next) {
    console.log('[NoCommingBack Guard]:[ASYNC] Guarding start.')

    let isDone = localStorage.getItem('isDone')

    if (to.meta.isAuth && isDone === 'isDone') {
        AuthService.logout(store, {}, () => {
            return next({ name: 'index' })
        })
    }

    console.log('[NoCommingBack Guard]:[ASYNC] Guarded.')
    
    return next()
}